export default {

    LOAD_BANNER(state, banner) {
        state.items = banner;
    }

}